import { EthereumHttpWeb3KeyProvider } from '@ankr.com/provider';
import { EthExecutionAPI, SimpleProvider } from 'web3';

export class ReadProvider extends EthereumHttpWeb3KeyProvider {
  constructor(
    url: string,
    public chainId: number,
  ) {
    super(url);
  }

  public getEIP1193Provider() {
    return this.getWeb3().currentProvider as SimpleProvider<EthExecutionAPI>;
  }
}
